/**
 * AKA product page.
 * Variant switching without a reload, and the gallery.
 *
 * Every variant's stock and price is already in the markup as data attributes on its radio,
 * so switching is a DOM read, not a fetch. The radio is the real form input, so the form
 * still submits the right variant if this script never runs.
 *
 * The main image is located by class rather than a data attribute, because image_tag cannot
 * take a hyphenated named argument and silently drops the whole tag if given one.
 */
(function () {
  function setText(root, selector, value) {
    const el = root.querySelector(selector);
    if (el) el.textContent = value || '';
    return el;
  }

  function setChip(root, chipSelector, valueSelector, value) {
    setText(root, valueSelector, value);
    const chip = root.querySelector(chipSelector);
    if (chip) chip.hidden = !value;
  }

  function initVariants(root) {
    const radios = Array.from(root.querySelectorAll('[data-jw-variant]'));
    if (!radios.length) return;

    const stockEl = root.querySelector('[data-jw-stock]');
    const priceEl = root.querySelector('[data-jw-price-value]');
    const stageEl = root.querySelector('[data-jw-stage]');
    const skuEl = root.querySelector('[data-jw-sku]');
    const mainImg = root.querySelector('.jw-pdp__main-img');

    function apply(radio) {
      const d = radio.dataset;

      if (stockEl) {
        stockEl.dataset.state = d.state || 'out';

        // Panel layout: a title, then a chip per fact.
        setText(stockEl, '[data-jw-stock-title]', d.title);
        setText(stockEl, '[data-jw-stock-count-label]', d.countLabel);
        setChip(stockEl, '[data-jw-stock-count-chip]', '[data-jw-stock-count]', d.count);
        setChip(stockEl, '[data-jw-stock-ready-chip]', '[data-jw-stock-ready]', d.ready);

        const note = setText(stockEl, '[data-jw-stock-note]', d.note);
        if (note) note.hidden = !d.note;

        // Compact layout, kept so a caller using the one-line form still updates.
        setText(stockEl, '[data-jw-stock-headline]', d.headline);
        const detail = setText(stockEl, '[data-jw-stock-detail]', d.detail);
        if (detail) detail.hidden = !d.detail;
      }

      if (priceEl && d.price) priceEl.textContent = d.price;

      if (stageEl) {
        stageEl.textContent = d.stage || '';
        stageEl.hidden = !d.stage;
      }

      if (skuEl) {
        skuEl.textContent = d.sku || '';
        const row = skuEl.closest('[data-jw-sku-row]');
        if (row) row.hidden = !d.sku;
      }

      // Only some variants carry their own photo. Leave the main image alone otherwise.
      if (mainImg && d.media && mainImg.tagName === 'IMG') {
        mainImg.src = d.media;
        mainImg.removeAttribute('srcset');
        syncThumbs(root, d.media);
      }

      if (d.variantId && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', d.variantId);
        window.history.replaceState({}, '', url);
      }
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) apply(radio);
      });
    });

    const checked = radios.find((r) => r.checked);
    if (checked) apply(checked);
  }

  function syncThumbs(root, src) {
    root.querySelectorAll('[data-jw-thumb]').forEach((t) => {
      t.setAttribute('aria-current', String(t.dataset.full === src));
    });
  }

  function initGallery(root) {
    const main = root.querySelector('.jw-pdp__main-img');
    const thumbs = Array.from(root.querySelectorAll('[data-jw-thumb]'));
    if (!main || main.tagName !== 'IMG' || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const full = thumb.dataset.full;
        if (!full) return;
        main.src = full;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || '';
        syncThumbs(root, full);
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-jw-product]').forEach((root) => {
      if (root.dataset.jwProductReady === 'true') return;
      root.dataset.jwProductReady = 'true';
      initGallery(root);
      initVariants(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
